import { useQuery } from 'react-query';
import { network } from 'services/network';
import { ISharedResourcesAvailabilityResponse } from 'components/widgets/Gantt/components/ganttChart.types';

const getSharedResourcesAvailability = (params) => {
    const url = `api/bo/getSharedResourcesForOverlappingActivities?metaDataId=${params.metaDataId}`;
    return network
        .get(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useSharedResourcesAvailability = (params) => {
    return useQuery<ISharedResourcesAvailabilityResponse, QueryError>(
        ['sharedResourcesAvailability', params],
        () => getSharedResourcesAvailability(params),
        {
            enabled: Boolean(params.metaDataId),
        },
    );
};
